<template>
  <div class="com-award-card" @click="openInApp">
    <img :src="cardItem.award_img" alt="" class="hb-img" />
    <p class="award-name">{{ cardItem.award_name }}</p>
  </div>
</template>
<script>
export default {
  props: {
    cardItem: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    console.log(this.cardItem);
  },
  methods: {
    openInApp() {
      window.location.href = this.cardItem.open_in_app;
    },
  },
};
</script>
<style lang="less">
.com-award-card {
  box-sizing: border-box;
  width: 130px;
  height: 84px;
  border-radius: 5px;
  border: 1px solid rgba(230, 230, 230, 1);
  overflow: hidden;
  .hb-img {
    width: 128px;
    height: 64px;
    object-fit: cover;
  }
  .award-name {
    margin: 2px 3px;
    font-size: 10px;
    line-height: 14px;
    font-weight: 500;
    color: rgba(20, 25, 30, 1);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
